export default __webpack_public_path__ + "static/media/transportation.d0723f27.png";